<template>
  <main>
    <crumbs :crumbs="crumbs"></crumbs>
    <div class="wrap">
      <div class="title-box">
        <div class="tit">我们的赞助商</div>
        <div class="desc">了解戴尔的赞助商如何帮助企业推动数字化转型，您可在此观看赞助商视频及下载相关资料。</div>
      </div>
      <div class="sponsor" v-if="showSponsor(1)">
        <div class="title">全球赞助商</div>
        <div class="line"></div>
        <div class="list">
          <div class="cen">
            <div class="item" v-for="item in sponsor" v-if="item.type == 1" @click="toSponsorDetail(item)">
              <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="sponsor" v-if="showSponsor(3)">
        <div class="title">金牌赞助商</div>
        <div class="line"></div>
        <div class="list ">
          <div class="left item" v-for="item in sponsor" v-if="item.type == 3" @click="toSponsorDetail(item,true)">
            <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
          </div>
        </div>
      </div>
      <div class="sponsor" v-if="showSponsor(2)">
        <div class="title">合作伙伴赞助商</div>
        <div class="line"></div>
        <div class="list ">
          <div class="cen">
            <div class="item" v-for="item in sponsor" v-if="item.type == 2" @click="toSponsorDetail(item)">
              <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-loading" v-if="show_loading">
        <loading></loading>
      </div>
    </div>
  </main>
</template>

<script>
    import Crumbs from "../../../components/m/Crumbs";
    import Loading from "../../../components/m/Loading";
    export default {
        name: 'sponsor',
        data() {
            return {
                query:"",
                sponsor:[],
                adv:{},
                swiper_1:'',
                swiper_2:"",
                show_loading:true,
            }
        },
        components:{
            Loading,
            Crumbs
        },
        computed:{
            crumbs() {
				return {title:"赞助商",min_title:"sponsor"}
            },
        },
        methods: {
            toSponsorDetail(item,link=false){
                if(item.show_detail == 2){
                    this.util.toLink(item.link,'','_blank');
                }else{
                    var url = "/sponsor/detail?sponsor_id="+item.id;
                    if(this.$store.state.user_info.id){
                        this.util.toLink(url);
                    }else{
                        this.util.toLink(url);
                    }
                }
            },
            showSponsor(type){
                var flag = false;
                for(var i =0;i<this.sponsor.length;i++){
                    if(this.sponsor[i].type == type){
                        flag = true;
                    }
                }
                return flag;
            },
            getSponsorList(){
                this.show_loading = true;
                this.http.request({
                    api:"sponsor/getSponsorList",
                    success:(res)=>{
                        this.sponsor = res.list;
                        this.show_loading = false;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getSponsorList();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background:#f6f6f6 url("~@/assets/image/2024/mobile/bottom_bg.png") no-repeat bottom center;background-size:100% auto;padding-top:.25rem;padding-bottom: .5rem;
        .title-box{padding:.25rem;background: #fff;box-shadow:0 0 .1rem .02rem rgba(0,0,0,.1);width: 6.5rem;margin: 0 auto;
            .tit{font-size:.26rem;line-height:.32rem;border-left: .04rem solid #1D56C0;padding-left:.1rem;font-weight: bold;}
            .desc{font-size: .22rem;margin-top: .1rem;line-height: .32rem;color:#565656;padding-left: .14rem;white-space: pre-line}
        }
        .sponsor{margin: .5rem auto 0;
            .title{font-size:.32rem;text-align: center}
            .line{width:1.4rem;height:.04rem;margin:.05rem auto 0; background: #1D56C0;}
            .list{overflow: hidden;margin: .3rem auto 0;padding: .2rem .25rem; text-align: center;
				.cen{display: block;}
                .item{float: left; width:3.4rem;height:1rem;box-shadow: 0 0 10px 5px rgba(0,0,0,.1);border-radius:.05rem;background: #fff;margin-bottom: .3rem;padding:0.2rem 0;
                    .logo{width: 2rem;height:1rem;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                }
				.item:nth-child(2n){float: right;}
				.item:nth-last-child(1){margin-bottom: 0;}
            }
            .list.list-l{
                .item{padding: .3rem .3rem 0;width: 2.8rem; background: #fff;margin-bottom: .2rem;
                    .logo{width:2rem;height:.7rem;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                }
                .item:nth-child(2n){float: right;}
            }
        }
    }
</style>

